"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ComponentHost;
(function (ComponentHost) {
    ComponentHost.getBootstrapConfigFromHtmlMetaTags = () => {
        const metaTags = document.getElementsByTagName('meta');
        const metaTagMap = {
            componentContext: metaTags.namedItem('com.orchestral.componentContext'),
            componentMetadata: metaTags.namedItem('com.orchestral.componentMetadata'),
            localeURL: metaTags.namedItem('com.orchestral.localeURL'),
            preferredLocale: metaTags.namedItem('com.orchestral.preferredLocale'),
            componentBasePath: metaTags.namedItem('com.orchestral.componentBasePath'),
            pingEnabled: metaTags.namedItem('com.orchestral.pingEnabled'),
            pingPeriod: metaTags.namedItem('com.orchestral.pingPeriod'),
            componentQueryParams: metaTags.namedItem('com.orchestral.componentQueryParams'),
            includeConcertoJS: metaTags.namedItem('com.orchestral.includeConcertoJS')
        };
        const componentHostConfig = {
            componentContext: metaTagMap.componentContext &&
                JSON.parse(metaTagMap.componentContext.content),
            componentMetadata: metaTagMap.componentMetadata &&
                JSON.parse(metaTagMap.componentMetadata.content),
            localeURL: metaTagMap.localeURL && metaTagMap.localeURL.content,
            preferredLocale: metaTagMap.preferredLocale && metaTagMap.preferredLocale.content,
            componentBasePath: metaTagMap.componentBasePath && metaTagMap.componentBasePath.content,
            pingEnabled: metaTagMap.pingEnabled
                ? metaTagMap.pingEnabled.content === 'true'
                : false,
            pingPeriod: metaTagMap.pingPeriod && Number(metaTagMap.pingPeriod.content),
            componentQueryParams: metaTagMap.componentQueryParams &&
                JSON.parse(metaTagMap.componentQueryParams.content),
            includeConcertoJS: metaTagMap.includeConcertoJS
                ? metaTagMap.includeConcertoJS.content === 'true'
                : false
        };
        if (metaTagMap.componentMetadata) {
            componentHostConfig.componentMetadata.componentConfig = JSON.parse(JSON.parse(metaTagMap.componentMetadata.content).componentConfig);
        }
        return componentHostConfig;
    };
})(ComponentHost = exports.ComponentHost || (exports.ComponentHost = {}));
//# sourceMappingURL=ComponentHost.js.map